(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ-Productpage"]) return;
  try {
    
var faq_labels = document.querySelectorAll(".faq-grid .label");
var faq_i;
   			 for (faq_i = 0; faq_i < faq_labels.length; faq_i++) {
      			faq_labels[faq_i].addEventListener('click', function () {
        			this.classList.toggle("active");
        			this.childNodes[0].classList.toggle("down");
        				var panel = this.nextElementSibling;
        				if (panel.style.maxHeight) {
          					panel.style.maxHeight = null;
        				} else {
                            ga('send','event','FAQ','FAQ-Click',this.innerText);
          					panel.style.maxHeight = panel.scrollHeight + "px";
						}
				});
}

  } catch(e) { console.error(e); }
})();
})();
